// Shared LLM model dropdown options. Backend accepts any model browser-use's
// ChatOpenAI / ChatGoogle accept; this list is the curated UX surface.
//
// `RUNTIME_MODELS` is for the live-runtime SurveyForm (self-host only — it's
// the one place we still surface a model picker, since live runs benefit from
// reasoning models).
// `REVIEWER_DEFAULT_MODEL` is the implicit choice for the Instrument Review
// fan-out — no picker exposed in the hosted UI; cost-sensitive default.

export interface ModelOption {
  value: string;
  label: string;
}

export const RUNTIME_MODELS: ModelOption[] = [
  { value: 'claude-sonnet-4-6', label: 'Claude Sonnet 4.6 (Recommended)' },
  { value: 'claude-sonnet-4-5', label: 'Claude Sonnet 4.5' },
  { value: 'gemini-3-flash-preview', label: 'Gemini 3 Flash' },
  { value: 'gpt-4.1', label: 'GPT-4.1' },
  { value: 'gpt-4o', label: 'GPT-4o' },
  { value: 'gpt-4o-mini', label: 'GPT-4o Mini' },
  { value: 'gpt-5-chat-latest', label: 'GPT-5 Chat Latest' },
];

export const RUNTIME_DEFAULT_MODEL = 'claude-sonnet-4-6';

export const REVIEWER_DEFAULT_MODEL = 'gpt-4o-mini';
